<template>
  <el-dialog
    v-model="formVisible"
    :title="
      '物业人员' + (status === 1 ? '新增' : status === 2 ? '编辑' : '详情')
    "
    @close="close"
    width="50%"
  >
    <div class="form_content">
      <h-anchor class="anchor" :idList="idList">
        <el-form
          ref="ruleFormRef"
          :model="ruleForm"
          :rules="rules"
          label-width="120px"
          class="userForm"
        >
          <div id="one">
            <div class="formTitle"><span></span>基本信息</div>
            <el-form-item label="姓名" prop="prisonName">
              <el-input
                v-model="ruleForm.prisonName"
                placeholder="姓名"
              ></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="sex">
              <h-selectcode
                type="sex"
                v-model="ruleForm.sex"
                placeholder="性别"
              ></h-selectcode>
            </el-form-item>
            <el-form-item label="手机号码" prop="telphone">
              <el-input
                v-model="ruleForm.telphone"
                placeholder="手机号码"
              ></el-input>
            </el-form-item>
          </div>
          <div id="two">
            <div class="formTitle"><span></span>岗位信息</div>
            <el-form-item label="所属物业" prop="propertyName">
              <el-input
                v-model="ruleForm.propertyName"
                placeholder="所属物业"
              ></el-input>
            </el-form-item>
            <el-form-item label="所属小区" prop="regionId">
              <el-select v-model="ruleForm.regionId" placeholder="所属小区">
                <el-option
                  v-for="item in options"
                  :key="item.regionId"
                  :label="item.name"
                  :value="item.regionId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="负责楼栋" prop="saveBuildRegionIds">
              <el-select
                :multiple="true"
                v-model="ruleForm.saveBuildRegionIds"
                placeholder="负责楼栋"
              >
                <el-option
                  v-for="item in optionss"
                  :key="item.regionId"
                  :label="item.name"
                  :value="item.regionId"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="岗位" prop="post">
              <el-input v-model="ruleForm.post" placeholder="岗位"></el-input>
            </el-form-item>
          </div>
          <div id="three" style="height: 480px">
            <div class="formTitle"><span></span>其他</div>
            <el-form-item label="入职时间" prop="entryTime">
              <el-date-picker
                v-model="ruleForm.entryTime"
                type="date"
                placeholder="入职时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="备注" prop="comment">
              <el-input
                v-model="ruleForm.comment"
                placeholder="备注"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </h-anchor>
    </div>
    <template #footer>
      <h-button type="primary" @click="submitForm(ruleFormRef)">保存</h-button>
      <h-button @click="formVisible = false">取消</h-button>
    </template>
  </el-dialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  ref,
  watch,
  onUnmounted,
} from "vue";
// import Validate from '@/utils/validate.js';
import util from "@util/js";
import { ElMessage } from "element-plus";
import {
  regionselect,
  propertysave,
  propertyupdate,
  propertyinfoinfo,
} from "@/api/realHouse/realHouse.js";
import Validate from "@/utils/validate.js";
import _ from "lodash";
export default defineComponent({
  name: "PropertyAdd",
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    status: {
      type: Number,
      default: 1, // 1 添加；2 编辑；3 只读
    },
  },
  emits: ["update:modelValue", "submit"],
  setup(props, context) {
    const ruleFormRef = ref();
    const validate = new Validate(ruleFormRef.value);
    const state = reactive({
      defaultPassword: "kzga110",
      formVisible: false,
      passwordType: 1,
      idList: [
        { name: "基本信息", id: "one", icon: "icon-shenfenzheng" },
        { name: "岗位信息", id: "two", icon: "icon-invite" },
        { name: "其他信息", id: "three", icon: "icon-shuidianbiaoguanli" },
      ],
      ruleForm: {
        propertyName: "",
        regionId: "",
        prisonName: "",
        sex: null,
        telphone: "",
        post: "",
        entryTime: "",
        comment: "",
        saveBuildRegionIds: "",
      },
      ruleFormBack: {},
      options: [],
      optionss: [],
      rules: {
        propertyName: [
          {
            required: true,
            message: "请输入物业名称",
            trigger: "blur",
          },
        ],
        regionId: [
          {
            required: true,
            message: "请选择所属小区",
            trigger: "blur",
          },
        ],
        prisonName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],

        entryTime: [
          {
            required: true,
            message: "请输入入职时间",
            trigger: "blur",
          },
        ],
        saveBuildRegionIds: [
          {
            required: true,
            message: "请选择负责楼栋",
            trigger: "blur",
          },
        ],
        telphone: [
          {
            required: true,
            validator: validate.tel,
            trigger: "blur",
          },
        ],
      },
    });
    state.ruleFormBack = _.cloneDeep(state.ruleForm);
    // state.ruleForm
    const refData = toRefs(state);

    // 初始化表单
    const initForm = async () => {
      if (props.status !== 1) {
        state.passwordType = 2;
      }
      ruleFormRef.value && ruleFormRef.value.resetFields();
      if (props.status === 2) {
        state.rules.telphone[0].required = false;
        const res = await propertyinfoinfo(props.form.propertyId);
        const form = { ...state.ruleForm, ...res.propertyInfo };
        if (props.form.buildRegionList) {
          form.saveBuildRegionIds = props.form.buildRegionList.map((item) => {
            return item.regionId;
          });
          console.log(form.saveBuildRegionIds);
        }
        state.ruleForm = _.cloneDeep(form);
      }
    };
    // 监听弹框显示因此
    watchEffect(() => {
      state.formVisible = props.modelValue;
    });
    watch(
      () => state.formVisible,
      (count, prevCount) => {
        if (props.status === 1) {
          state.rules.telphone[0].required = true;
        }
        initForm();
      }
    );
    watch(
      () => state.ruleForm.regionId,
      async () => {
        const paramss = {
          parentId: state.ruleForm.regionId,
          // type: 4,
        };
        const ress = await regionselect(paramss);
        state.optionss = ress.data;
      }
    );
    watchEffect(() => {
      context.emit("update:modelValue", state.formVisible);
    });
    watchEffect(() => {
      //编辑时有值且不带*验证
      if (
        props.status !== 1 &&
        state.ruleForm.telphone &&
        state.ruleForm.telphone.toString().indexOf("*") == -1
      ) {
        state.rules.telphone[0].required = true;
      }
    });

    // 保存表单数据
    const submitForm = (formEl) => {
      console.log(props.status);
      console.log(formEl);
      if (!formEl) return;
      console.log(formEl);
      formEl.validate(async (valid) => {
        console.log(valid);
        if (valid) {
          const form = _.cloneDeep(state.ruleForm);
          util.formatForm(form);
          const arr = ["telphone"];
          util.formatFormNumber(form, arr); //删除号码中带  * 的
          console.log(props.status);
          let res;
          // 1添加 2编辑
          if (props.status === 1) {
            Reflect.deleteProperty(form, "propertyId");
            res = await propertysave(form);
          } else if (props.status === 2) {
            res = await propertyupdate(form);
          }
          if (res.code === 0) {
            state.formVisible = false;
            ElMessage.success("操作成功");
            context.emit("submit");
          }
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };
    const close = () => {
      state.ruleForm = _.cloneDeep(state.ruleFormBack);
    };
    const regionselectAxios = async () => {
      const params = {
        type: 3,
      };
      const res = await regionselect(params);
      state.options = res.data;
    };
    regionselectAxios();

    return {
      ...refData,
      submitForm,
      close,
      ruleFormRef,
    };
  },
});
</script>
<style lang="scss" scoped>
.form_content {
  max-height: 500px;
  overflow: auto;
  .anchor {
    max-height: 480px;
  }
  .formTitle {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    span {
      width: 3.5px;
      height: 16px;
      background-color: #5584ff;
      margin-right: 10px;
    }
  }
}
</style>
